import React from "react";
import { Link } from "react-router-dom";

export const ModuleContent = ({ title, imgSrc, items }) => {
  return (
    <div>
      <div className="flex items-center text-center mb-6">
        <img
          className="w-16 aspect-square mr-3"
          src={imgSrc}
          alt="Expanded Module Icon"
        />
        <h2 className="text-3xl text-sss-blue">{title}</h2>
      </div>
      <ul>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <li className="mb-4 last:mb-0 text-lg font-sans">
              {item.disabled || !item.path ? (
                <span className="text-gray-300 hover:cursor-not-allowed">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="hover:underline hover:text-sss-info"
                >
                  {item.name}
                </Link>
              )}
            </li>
            {item.showDivider && (
              <div className="border-t border-2 border-sss-blue my-2 w-1/2"></div>
            )}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

export default ModuleContent;
